export const getExtensionsString = (arr: string[]) =>
  arr.map((extension) => `.${extension}`).join(', ');
